module.exports = __webpack_public_path__ + "img/demo-booking-left-info.90b90b0f.webp";